import { EnviromentTyping } from "./enviroment-typings";

export const environment: EnviromentTyping = {
    production: true,
    apiUrl: {
      identity: "https://api-dev.one.on-n1.com/identity",
      orga: "https://api-dev.one.on-n1.com/orga",
      data: "https://api-dev.one.on-n1.com/data",
      tech: "https://api-dev.one.on-n1.com/tech",
      pageDefaultSize: 25,
      defaultTimeoutSec: 30,
      tokenExpireOffsetSec: 59
    },
    lang: {
      defaultLanguage: "de-DE",
      useBrowserLanguage: false
    },
    idle: {
      autoRefreshOnViewAfter: 1000 * 60 * 2,
      idleTime: 60 * 30
    },
    alert: {
      batteryStatusAlertLevel: 20
    },
    image: {
      formImageResizeMaxSize: 1366
    },
    interceptor: {
      additionalHttpApiClientInterceptorsIdentifier: "additionalHttpApiClientInterceptors",
      apiPageDefaultSizeIdentifier: "apiPageDefaultSize",
      apiDefaultTimeoutSecIdentifier: "apiDefaultTimeoutSec"
    }
  };
